module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "toc"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fmh1"
  }, [_vm._v("\n    Table of Contents\n  ")]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/alex_9781571318060_oeb_fm1_r1"
    }
  }, [_vm._v("ALSO BY ALEX LEMON")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/alex_9781571318060_oeb_tp_r1"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/alex_9781571318060_oeb_ded_r1"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/alex_9781571318060_oeb_fm2_r1"
    }
  }, [_vm._v("come sweetly")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cpt"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/alex_9781571318060_oeb_p01_r1"
    }
  }, [_vm._v("!")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/alex_9781571318060_oeb_c01_r1"
    }
  }, [_vm._v("being here")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/alex_9781571318060_oeb_c02_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("all of the made roads")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/alex_9781571318060_oeb_c03_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("way out west")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/alex_9781571318060_oeb_c04_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ghost in the latrine")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/alex_9781571318060_oeb_c05_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("more wind")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/alex_9781571318060_oeb_c06_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("it had only been dead a few hours")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/alex_9781571318060_oeb_c07_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("haunt")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/alex_9781571318060_oeb_c08_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("the floppy instant")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/alex_9781571318060_oeb_c09_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here comes the mojo")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/alex_9781571318060_oeb_c10_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("california hates you")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/alex_9781571318060_oeb_c11_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("beautification campaign")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/alex_9781571318060_oeb_c12_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("verde vista")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/alex_9781571318060_oeb_c13_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("bling ding bling")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/alex_9781571318060_oeb_c14_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("pins & needles")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/alex_9781571318060_oeb_c15_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("heat")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/alex_9781571318060_oeb_c16_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("redux")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/alex_9781571318060_oeb_c17_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("i love you big brother")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/alex_9781571318060_oeb_c18_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("shall we be merry?")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/alex_9781571318060_oeb_c19_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("fantasy island")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/alex_9781571318060_oeb_c20_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("tick tick tick")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/alex_9781571318060_oeb_c21_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("there’s so little to do in a hospital bed")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/alex_9781571318060_oeb_c22_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("the new math")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/alex_9781571318060_oeb_c23_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("my fallow human beans")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cpt"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/alex_9781571318060_oeb_p02_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("!!")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cpt"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/alex_9781571318060_oeb_p03_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("!!!")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/alex_9781571318060_oeb_c24_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("starved")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/alex_9781571318060_oeb_c25_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("fancy beasts")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/alex_9781571318060_oeb_c26_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("house rulez")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/alex_9781571318060_oeb_c27_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("the nice")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/alex_9781571318060_oeb_c28_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("come get some")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/alex_9781571318060_oeb_c29_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("modern life")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/alex_9781571318060_oeb_c30_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("we could boom boom")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/alex_9781571318060_oeb_c31_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("erasure")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/alex_9781571318060_oeb_c32_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("the big one")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/alex_9781571318060_oeb_c33_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a little bit now")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/alex_9781571318060_oeb_c34_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("cittern")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/alex_9781571318060_oeb_c35_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("the physics of sawing yourself in half")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/alex_9781571318060_oeb_c36_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("please please more napalm")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/alex_9781571318060_oeb_c37_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("operation: get down")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/alex_9781571318060_oeb_c38_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("dear dysentery")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/alex_9781571318060_oeb_c39_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("all aboard")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/alex_9781571318060_oeb_ata_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ABOUT THE AUTHOR")])]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/alex_9781571318060_oeb_ack_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/alex_9781571318060_oeb_bm1_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("more books from milkweed editions")])]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/alex_9781571318060_oeb_cop_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Page")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c36d911","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/alex_9781571318060_oeb_toc_r1.vue
// module id = 57
// module chunks = 0